import * as React from 'react'
import { FormattedHTMLMessage } from 'react-intl'

import Button from '../../../../components/button'
import FreeHandwriting from '../../../free/components/free-handwriting'

import LevelCard from './level-card'
import styles from './subfeatures.module.scss'

const SubFeatures: React.FC<{
  handleClickRegister: () => void
}> = ({ handleClickRegister }) => (
  <div className={styles.root}>
    <Button bankId onClick={() => handleClickRegister()} variant="success">
      <FormattedHTMLMessage defaultMessage="Logga in och börja bokföra" id="diy-accounting.sub-features.cta" />
    </Button>
    <div className={styles.outer}>
      <div className={styles.handwritingWrapper}>
        <FreeHandwriting
          text={
            <FormattedHTMLMessage
              defaultMessage="…and it's gratis"
              id="diy-accounting.sub-features.free"
              tagName="h3"
            />
          }
          variant="left"
        />
      </div>
      <div className={styles.inner}>
        <LevelCard />
      </div>
    </div>
  </div>
)

export default SubFeatures
